<template>
    <Field :name="name" v-slot="{ field, errors }" v-bind="fieldValidateOn">
        <Checkbox
            v-model="field.value"
            @update:modelValue="field['onUpdate:modelValue']"
            @blur="field.onBlur"
            :errorMessages="errors"
            :field-error="!isEmpty(errors)"
            v-bind="input">
            <slot />
        </Checkbox>
    </Field>
</template>

<script lang="ts">
    import { PropType, ExtractPropTypes, defineComponent, inject } from 'vue';
    import { FieldValidateOn } from '../../Validations/Validations.interfaces';
    import { Field } from 'vee-validate';
    import { isEmpty } from 'lodash';
    import Checkbox from './Checkbox.vue';

    type CheckboxProps = ExtractPropTypes<typeof Checkbox.props>;

    export default defineComponent({
        name: 'CheckboxField',
        methods: { isEmpty },
        components: { Field, Checkbox },
        props: {
            name: {
                type: String,
                required: true,
            },
            input: {
                type: Object as PropType<Partial<CheckboxProps>>,
                default: () => ({}),
            },
        },
        setup() {
            const fieldValidateOn = inject('fieldValidateOn') as FieldValidateOn;

            return { fieldValidateOn };
        },
    });
</script>
